var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "plan-slot",
      class: "ruolo_" + _vm.Constants.RUOLO[_vm.ruolo_abc],
    },
    [
      _c(
        "div",
        {
          staticClass: "ruolo-pos",
          attrs: { "aria-label": _vm.ruolo_abc + ", posizione " + (_vm.i + 1) },
        },
        [
          _c("span", { staticClass: "ruolo-label" }, [
            _vm._v(_vm._s(_vm.ruolo_abc)),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "pos" }, [_vm._v(_vm._s(_vm.i + 1))]),
        ]
      ),
      _vm._v(" "),
      _vm.associato
        ? _c(
            "div",
            { staticClass: "nomi-calciatori associato" },
            [
              _c(
                "div",
                { staticClass: "plan-player-info" },
                [
                  _c("maglia-or-flag-plus-nome", {
                    attrs: { calciatore: _vm.calciatori[_vm.associato] },
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _c("span", { staticClass: "associato-name" }, [
                      _vm._v(_vm._s(_vm.nomeCalciatoreAssociato)),
                    ]),
                    _vm._v(" "),
                    _vm.mantra && _vm.ruoliMantraAssociato.length
                      ? _c(
                          "span",
                          { staticClass: "plan-mantra-roles" },
                          _vm._l(_vm.ruoliMantraAssociato, function (mantraId) {
                            return _c("ruolo-mantra", {
                              key: mantraId,
                              attrs: { "mantra-id": mantraId, small: "" },
                            })
                          }),
                          1
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _vm.calciatori[_vm.associato] && _vm.calciatori[_vm.associato].ms
                ? _c("main-status", {
                    staticClass: "flex-shrink-0 mx-1",
                    attrs: { ms: _vm.calciatori[_vm.associato].ms, small: "" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "azione-associa associato",
                  attrs: {
                    icon: "",
                    "x-small": "",
                    disabled: _vm.onlyAssociaSlot || _vm.readonly,
                    "aria-label": "Rimuovi calciatore dallo slot",
                  },
                  on: { click: _vm.disassocia },
                },
                [
                  _c(
                    "v-icon",
                    { staticClass: "navy--text", attrs: { small: "" } },
                    [_vm._v("close")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            {
              staticClass: "nomi-calciatori obiettivi-calciatori",
              class: {
                disabled:
                  _vm.onlyAssociaSlot || _vm.readonly || _vm.fuoriLimite,
              },
              on: { click: _vm.promptAddObiettivo },
            },
            [
              _c(
                "div",
                { staticClass: "obiettivi-list" },
                [
                  _vm.obiettiviVisibili.length == 0
                    ? _c("span", { staticClass: "obiettivi-placeholder" }, [
                        _vm._v("\n        Aggiungi obiettivo\n      "),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.obiettiviVisibili, function (obiettivo) {
                    return _c(
                      "span",
                      {
                        key: obiettivo.id,
                        staticClass: "obiettivo-chip",
                        class: {
                          "has-mantra":
                            _vm.mantra && obiettivo.mantra_ids.length,
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.removeObiettivo(obiettivo.id)
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "plan-player-info" }, [
                          _c("span", { staticClass: "obiettivo-name" }, [
                            _vm._v(_vm._s(obiettivo.nome)),
                          ]),
                          _vm._v(" "),
                          _vm.mantra && obiettivo.mantra_ids.length
                            ? _c(
                                "span",
                                { staticClass: "plan-mantra-roles" },
                                _vm._l(
                                  obiettivo.mantra_ids,
                                  function (mantraId) {
                                    return _c("ruolo-mantra", {
                                      key: mantraId,
                                      attrs: {
                                        "mantra-id": mantraId,
                                        small: "",
                                      },
                                    })
                                  }
                                ),
                                1
                              )
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticClass: "obiettivo-remove",
                            attrs: {
                              "x-small": "",
                              icon: "",
                              disabled:
                                _vm.onlyAssociaSlot ||
                                _vm.readonly ||
                                _vm.fuoriLimite,
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.removeObiettivo(obiettivo.id)
                              },
                            },
                          },
                          [
                            _c("v-icon", { attrs: { "x-small": "" } }, [
                              _vm._v("close"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              (_vm.acquistiSenzaSlotPerRuolo[_vm.ruolo_abc] || []).length > 0
                ? _c(
                    "v-btn",
                    {
                      staticClass: "azione-associa evidenzia",
                      class: { evidenzia: _vm.onlyAssociaSlot },
                      attrs: {
                        icon: "",
                        "x-small": "",
                        disabled: _vm.readonly || _vm.fuoriLimite,
                        "aria-label": "Associa un calciatore allo slot",
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          _vm.overrideAssociaClick
                            ? _vm.overrideAssociaClickCb()
                            : _vm.associaCalciatore()
                        },
                      },
                    },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "navy--text", attrs: { small: "" } },
                        [_vm._v("add")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
      _vm._v(" "),
      _vm.associato
        ? _c(
            "div",
            { staticClass: "crediti-pianificati associato" },
            [_c("crediti", { attrs: { crediti: _vm.pagato } })],
            1
          )
        : _c(
            "v-btn",
            {
              staticClass: "crediti-pianificati",
              attrs: {
                disabled:
                  _vm.onlyAssociaSlot || _vm.readonly || _vm.fuoriLimite,
              },
              on: { click: _vm.showNumpad },
            },
            [_vm._v(_vm._s(_vm.pCrediti == 0 ? "..." : _vm.pCrediti))]
          ),
      _vm._v(" "),
      _vm.append
        ? _c(
            "div",
            [
              _c("v-icon", { staticClass: "white--text" }, [
                _vm._v("chevron_right"),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.append
        ? _c("div", { staticClass: "new-plan" }, [
            _vm._v("\n    " + _vm._s(_vm.append) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "500",
            "retain-focus": false,
            persistent: _vm.disassociando,
          },
          model: {
            value: _vm.dialogDisassocia,
            callback: function ($$v) {
              _vm.dialogDisassocia = $$v
            },
            expression: "dialogDisassocia",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "navy" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "secondary white--text d-flex align-center font-hemi-head pa-4",
                },
                [
                  _c("span", { staticStyle: { "font-size": "16px" } }, [
                    _vm._v(
                      "\n          Rimuovi il calciatore acquistato da questo slot\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        depressed: "",
                        icon: "",
                        disabled: _vm.disassociando,
                        "aria-label": "Chiudi",
                      },
                      on: {
                        click: function ($event) {
                          _vm.dialogDisassocia = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "white--text pt-4" },
                [
                  _c("p", [
                    _vm._v(
                      "Rimuovi il calciatore acquistato da questo slot... e poi mettilo in un altro slot premendo sul relativo “+” che ti comparirá."
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-alert",
                    { attrs: { dense: "", text: "", type: "info" } },
                    [
                      _c("div", [
                        _c("b", [
                          _vm._v(
                            "Occhio, il calciatore resterá comunque nella tua rosa!"
                          ),
                        ]),
                      ]),
                      _vm._v(
                        "\n          Se volevi annullare l’assegnazione, clicca su\n          "
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            "x-small": "",
                            outlined: "",
                            color: "accent",
                            disabled: _vm.disassociando,
                          },
                          on: { click: _vm.showRoseLega },
                        },
                        [_vm._v("ROSE")]
                      ),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(
                          " → tre puntini in corrispondenza del calciatore → Rimetti svincolato"
                        ),
                      ]),
                      _vm._v(".\n        "),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-checkbox", {
                    attrs: {
                      label: "Non mostrare più",
                      disabled: _vm.disassociando,
                      "hide-details": "",
                      color: "secondary",
                    },
                    model: {
                      value: _vm.nonMostrareDisassocia,
                      callback: function ($$v) {
                        _vm.nonMostrareDisassocia = $$v
                      },
                      expression: "nonMostrareDisassocia",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "flex-wrap justify-end pa-4" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", disabled: _vm.disassociando },
                      on: {
                        click: function ($event) {
                          _vm.dialogDisassocia = false
                        },
                      },
                    },
                    [_vm._v("\n          Annulla\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "secondary",
                      attrs: { loading: _vm.disassociando },
                      on: { click: _vm.confermaDisassocia },
                    },
                    [
                      _vm._v(
                        "\n          Capito. Rimuovi da questo slot\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }